"use client";

import { cva, type VariantProps } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import { BaseInput, type BaseInputProps } from "./input";

const conEdisonInputVariants = cva({
  base: [
    "w-full rounded-b-none border-none p-0 pb-1 text-center text-3xl! font-semibold sm:text-[2rem]",
    "ring-offset-transparent focus-visible:border-none! focus-visible:ring-0 focus-visible:ring-offset-0  bg-transparent! ring ring-offset-0 ring-transparent! before:shadow-none! shadow-none!", // unsetting unneeded styles from base input
  ],
  variants: {
    variant: {
      default: "",
      ghost: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface ConEdisonInputProps extends Omit<BaseInputProps, "variant"> {
  variant?: VariantProps<typeof conEdisonInputVariants>["variant"];
}

export type InputFocusEvent = Parameters<
  Exclude<ConEdisonInputProps["onFocus"], undefined>
>[0];

export default function ConEdisonInput({
  className,
  variant,
  ...props
}: ConEdisonInputProps) {
  // trigger onBlur + onFocus on mount (if con edison)
  // TODO: WHY do we need this?
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!props.autoFocus) {
  //       onFocus?.();
  //       onBlur?.();
  //     }
  //   });
  // }, [onBlur, onFocus, props.autoFocus]); // eslint-disable-line react-hooks/exhaustive-deps

  // TODO: test that input autofill for con edison inputs works without this
  // fix autofill not triggering onBlur
  // const hasTriggeredBlurOnFirstValueChangeAndNotFocused = useRef(false);
  // const shouldTriggerBlurOnFirstValueChangeAndNotFocused = true;
  // useEffect(() => {
  //   if (!shouldTriggerBlurOnFirstValueChangeAndNotFocused) return;
  //   if (hasTriggeredBlurOnFirstValueChangeAndNotFocused.current) return;
  //   if (!props.value) return;
  //   if (isFocusedRef.current) return;

  //   onFocus?.();
  //   onBlur?.();
  //   hasTriggeredBlurOnFirstValueChangeAndNotFocused.current = true;
  // }, [props.value, onFocus, onBlur]);

  return (
    <div>
      <BaseInput
        {...props}
        className={cn(
          conEdisonInputVariants({
            variant,
            className,
          }),
          className,
        )}
      />
      <div className="border-website-border border-b-2" />
    </div>
  );
}
